import { Component, EventEmitter, Output, OnInit, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import { Inject } from '@angular/core';
import { NgxActivityService } from '@go-modules/services/activity/activity.service';
import { ROUTE_NAMES, RouterService } from '@go-modules/services/router/router.service';

interface NavigationItem {
	name: string;
	route: string;
	translationKey: string;
}

@Component({
	selector: 'activity-navigation',
	imports: [
		TranslateModule
	],
	templateUrl: './activity-navigation.component.html',
	styleUrls: ['./activity-navigation.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityNavigationComponent implements OnInit, AfterViewInit {
	@Output() public navigationSelected = new EventEmitter<void>();
	public navigationItems: NavigationItem[] = [
		{
			name: 'Submissions',
			route: ROUTE_NAMES.DASHBOARD_ACTIVITY_VIEW,
			translationKey: 'common_submissions'
		},
		{
			name: 'Task Report',
			route: ROUTE_NAMES.DASHBOARD_ACTIVITY_TASK_REPORT,
			translationKey: 'activity-view_navigation-task-report'
		},
		{
			name: 'Activity Report',
			route: ROUTE_NAMES.DASHBOARD_ACTIVITY_REPORT,
			translationKey: 'activity-report_header-title'
		}
	];
	public selectedRoute: string | null = null;

	constructor (
		public activityService: NgxActivityService,
		private routerService: RouterService,
		@Inject(selectedServiceToken) private selectedService: SelectedService
	) {}

	public ngOnInit (): void {
		const currentRoute = this.routerService.getCurrentRouteName();
		if (currentRoute) {
			this.selectedRoute = currentRoute;
		}
	}

	public ngAfterViewInit (): void {
		this.navigationSelected.emit();
	}

	public onNavigationClick (navigationItem: NavigationItem): void {
		this.navigationSelected.emit();
		this.selectedRoute = navigationItem.route;

		const activity = this.selectedService.getActivity();
		if (activity) {
			this.routerService.navigateTo(navigationItem.route as ROUTE_NAMES, {
				activity_id: activity.activity_id
			});
		}
	}
}
